import merge from 'lodash-es/merge';
import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  production: false,
  isLocal: false,
};

export const environment = merge(commonEnv, env);
